/**
 * Curated set of app categories. Used by the deploy form's category
 * picker and by the dashboard tab rail. Adding a new category requires
 * a code change — this is intentional to keep the tab bar clean.
 */
export const APP_CATEGORIES: readonly string[] = [
  'User Apps',
  'Internal Tools',
  'Analytics',
  'Infrastructure',
  'Security',
  'Operations',
  'Documentation',
];

/** Default category selected when the user hasn't explicitly picked one. */
export const DEFAULT_APP_CATEGORY = 'User Apps';
